// extracted by mini-css-extract-plugin
module.exports = {"description":"ContentsHeader_description__2c0Bj"};